module.exports = __webpack_public_path__ + "static/texturascomplementarias-3b6236118af0bbedadcb3900540f7e96.pdf";